import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert, { AlertColor as Color } from '@mui/material/Alert';

export interface AppErrorMessageProps {
  open: boolean;
  message: React.ReactNode;
  onClose: () => void;
  severity?: Color;
  autoHideDuration?: number;
  anchorOrigin?: {
    vertical: 'top' | 'bottom';
    horizontal: 'left' | 'center' | 'right';
  };
}

const AppErrorMessage: React.FC<AppErrorMessageProps> = ({
  open,
  message,
  onClose,
  severity = 'error',
  autoHideDuration = 6000,
  anchorOrigin = { vertical: 'top', horizontal: 'center' },
}) => {
  if (!message) return null;
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert severity={severity} onClose={onClose} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};

export default AppErrorMessage;
